import { useWindowSize } from '@vueuse/core';
import { watch, onMounted } from 'vue';
import { useAppStore } from '@/app/stores/app.store.js';

/**
 * Auto-collapse/open sidebars based on window width
 * - Primary sidebar: Auto-collapse when width < 1280px (xl)
 * - Content sidebar: Auto-open when width >= 1024px (lg)
 * Triggers on initial load and window resize events
 */
export const useSidebarAutoCollapse = () => {
    const { width } = useWindowSize();
    const appStore = useAppStore();
    const PRIMARY_COLLAPSE_THRESHOLD = 1280; // xl breakpoint
    const CONTENT_OPEN_THRESHOLD = 1024; // lg breakpoint

    // Watch for threshold crossings on window resize
    watch(width, (newWidth, oldWidth) => {
        // Primary sidebar: Auto-collapse when crossing DOWN the xl threshold
        if (oldWidth >= PRIMARY_COLLAPSE_THRESHOLD && newWidth < PRIMARY_COLLAPSE_THRESHOLD) {
            appStore.sidebarExpanded = false;
        }

        // Content sidebar: Auto-open when crossing UP the lg threshold
        if (oldWidth < CONTENT_OPEN_THRESHOLD && newWidth >= CONTENT_OPEN_THRESHOLD) {
            appStore.contentSidebarOpen = true;
        }
    });

    onMounted(() => {
        // Primary sidebar: Collapse if below threshold
        if (width.value < PRIMARY_COLLAPSE_THRESHOLD && appStore.sidebarExpanded) {
            appStore.sidebarExpanded = false;
        }

        // Content sidebar: Open if at or above threshold
        if (width.value >= CONTENT_OPEN_THRESHOLD) {
            appStore.contentSidebarOpen = true;
        }
    });
};
